<template>
    <div>
        <v-card dark>
            <v-card-title class="d-flex justify-space-between">
                <div>
                    <span class="text-h6">Filtros {{tableActive}}</span>
                </div>
                <div>
                    <v-icon>mdi-filter</v-icon>
                </div>
            </v-card-title>
            <!-- Filtros para Produtos -->
            <div v-if="tableActive.toLowerCase() == 'produtos'">
            <v-card-text class="d-flex flex-wrap">
                <div class="d-flex flex-wrap">
                    <v-text-field
                        class="mr-1"
                        dark dense outlined
                        label="Categoria" placeholder="Escolha a categoria"
                        v-model="filters.product.category"
                    />
                    <v-text-field
                        dark dense outlined
                        class="mr-1"
                        label="Estoque <" placeholder="Estoque menor que X"
                        v-model="filters.product.lessThen"
                    />
                    <v-text-field
                        class="mr-1"
                        dark dense outlined
                        label="Estoque >" placeholder="Estoque maior que X"
                        v-model="filters.product.greaterThen"
                    />
                    <v-switch
                        dark dense outlined
                        label="Frete Grátis"
                        v-model="filters.product.freeShipping"
                    />                                        
                </div>
            </v-card-text>
            <v-card-actions>
                <v-btn color="info" @click="searchProducts">
                    <span>Buscar</span>
                </v-btn>
            </v-card-actions>
            </div>

        </v-card>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
    data: () => {
        return {
            filters:{
                product:{
                    category: '',
                    lessThen: '',
                    greaterThen:'',
                    freeShipping: false
                }
            }
        }
    },
    computed: {
        ...mapGetters({
            categoryComboBox: 'isetModule/getCategoryIntegratedComboBox'
        }),
    },
    props:{
        tableActive: {
            type: String,
            default: '',
            required: true
        }
    },
    methods:{
        ...mapActions({
            getCategories: 'isetModule/getCategories'
        }),
        async requestIntegratedCategories(){
            try{
                await this.getCategories({integrados:'S'})
            }catch(error){
                this.$toasted.error(error, {duration: null})
            }
        },
        searchProducts(){
            let filterData = {action: '', filters: {}}
            filterData.action = 'produtos.lista'    
            if(this.filters.product.category != '')
                filterData.filters.categoryId = this.filters.product.category
            if(this.filters.product.lessThen != '')
                filterData.filters.stockLessThen = this.filters.product.lessThen
            if(this.filters.product.greaterThen != '')
                filterData.filters.stockGreaterThen = this.filters.product.greaterThen
            if(this.filters.product.freeShipping)
                filterData.filters.freeShipping = this.filters.product.freeShipping
            
            
            this.$emit('filter', filterData)
        }
    },
    mounted(){
        if(this.categoryComboBox.length <= 0)
            this.requestIntegratedCategories()
    }
}
</script>

<style>

</style>